























































import {
  defineComponent, defineAsyncComponent, ref, onMounted, onBeforeUnmount, computed,
} from '@vue/composition-api';

import { checkSuperCardMyPageShow } from '@/api/rights/index';
import {
  CheckSuperCardMyPageShow, PackageBuyStatusEnum, SuperMemberSourceEnum, RightPackageTypeEnum,
  SuperCardStyleTypeEnum,
} from '@/api/rights/types';
import { RIGHTS_DETAIL_POPUP, RIGHTS_ENTER } from '@/shared/right-utils/ubtRights';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { RightHelper } from '@/shared/right-router-helper';
import { openThirdPage } from '@/api/native/utils';
import { changeTabbarShowStatus, getSkTabInfo, skNativeContainer } from '@/api/native/container';
import { listerBack } from '@/shared/utils/backListener';

/** 购买弹窗组件 */
const BuyPopup = () => import(
  /* webpackChunkName: "async-buy-popup" */ './components/BuyPopup.vue'
);

const SuperMemberBuyPopup = defineAsyncComponent(BuyPopup);

export default defineComponent({
  components: {
    SuperMemberBuyPopup,
  },
  setup() {
    /** 接口返回时概要数据 */
    const superMemberCardShow = ref<CheckSuperCardMyPageShow>();

    /** 获取超级会员概要数据 */
    const superMemberCardSummary = async (): Promise<void> => {
      superMemberCardShow.value = await checkSuperCardMyPageShow();
    };

    /** 展示购买弹窗 */
    const showBuyPopup = ref<boolean>(false);

    /** 统一埋点参数上报 */
    const tqParams = computed(() => {
      const {
        packageId, packageType, supplierCode, sellPrice, packageBuyStatus, packageName,
      } = superMemberCardShow.value || {};
      return {
        packageId,
        packageType,
        supplierCode,
        sellPrice,
        packageName,
        packageBuyStatus,
        from: SuperMemberSourceEnum.MY_PROFILE,
      };
    });

    /** 是否是合规样式版本 实验由后端接入 */
    const isPatternA = computed(() => superMemberCardShow.value
                                      && superMemberCardShow.value.extraInfo
                                      && superMemberCardShow.value.extraInfo.pattern === 'patternA');

    /** 有订单 去往会员详情页 */
    const goOrderDetail = () => {
      if (superMemberCardShow.value?.orderId) {
        const url = RightHelper.dispatchRouterByBuyStatus(
          superMemberCardShow.value.packageType,
          SuperMemberSourceEnum.MY_PROFILE,
          PackageBuyStatusEnum.BOUGHT,
          superMemberCardShow.value.orderId,
        );
        openThirdPage(url);
      }
    };

    /** 无订单 去往会员详情页 */
    const goDetail = () => {
      if (superMemberCardShow.value?.packageBuyStatus === PackageBuyStatusEnum.NOT_BUY) {
        const url = RightHelper.dispatchRouterByBuyStatus(
          superMemberCardShow.value.packageType,
          SuperMemberSourceEnum.MY_PROFILE,
          PackageBuyStatusEnum.NOT_BUY,
        );
        openThirdPage(url);
      }
      /** 监听回退事件 */
      document.addEventListener('visibilitychange', () => {
      /** 此处重新调用接口的意义是 保证用户进入详情页购买超级会员后回退 页面状态更新 */
        if (document.visibilityState === 'visible') {
          superMemberCardSummary();
        }
      });
    };

    /** 打开购买引导弹窗 */
    const openBuyPopup = () => {
      ubtSetupModuleExpose(RIGHTS_DETAIL_POPUP, tqParams.value);
      showBuyPopup.value = true;
      /** 隐藏tabbar */
      changeTabbarShowStatus(false);
    };

    /** 关闭引导弹窗 */
    const closeBuyPopup = (value:boolean) => {
      showBuyPopup.value = value;
      if (!value) {
        /** 待popup完全消失后，显示tabbar */
        setTimeout(() => {
          changeTabbarShowStatus(true);
        }, 300);
      } else {
        /** 隐藏tabbar */
        changeTabbarShowStatus(false);
      }
    };

    const initData = async () => {
      await superMemberCardSummary();
      if (superMemberCardShow.value) {
        /** 接口返回数据有数据时曝光 */
        ubtSetupModuleExpose(RIGHTS_ENTER, tqParams.value);
      }
    };

    onMounted(async () => {
      const { haveShown } = await getSkTabInfo('my');
      if (await skNativeContainer()) {
        if (haveShown) {
          initData();
        }
        /** 不能自动取消 需要持续监听 */
        /** 监听app容器切换 */
        listerBack(async () => {
          initData();
        }, false);
      } else {
        initData();
      }
    });

    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', () => {
        superMemberCardSummary();
      });
    });

    return {
      superMemberCardShow,
      PackageBuyStatusEnum,
      RightPackageTypeEnum,
      SuperCardStyleTypeEnum,
      showBuyPopup,
      isPatternA,

      goOrderDetail,
      goDetail,
      openBuyPopup,
      closeBuyPopup,
      superMemberCardSummary,
    };
  },
});
